<template>
	<div>
		<img src="/img/bertha/bertha-full-multicolor-LightMode.svg" :style="`height: ${height}`" class="mr-1" />
		<span :style="`font-size: ${height}`">AI Assistant</span>
	</div>
</template>

<script>

export default {
	name: 'BerthaAIAssistant',
	props: {
		height: {
			type: String,
			default: '1rem'
		}
	}
}
</script>
